import React from 'react';
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn} from "react-icons/fa";

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/kevinfvckingrifo'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/in/kevin-rifo-buana-1919b8197/'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/xyzonalyz'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/ateisberiman'},
]

const FooterTwo = () => {
    return (
        <div className="footer-style-2 ptb--25 bg_image bg_image--1" data-black-overlay="6">
            <div className="wrapper plr--50 plr_sm--20">
                <div className="row align-items-center justify-content-between">
               
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                        <div className="inner text-center">
                            <ul className="social-share rn-lg-size d-flex justify-content-center liststyle">
                                {SocialShare.map((val , i) => (
                                    <li key={i}><a href={`${val.link}`}>{val.Social}</a></li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                        <div className="inner text-lg-right text-left mt_md--20 mt_sm--20 mr-5">
                            <div className="text">
                            <p> © {new Date().getFullYear()} <strong> Kevin Rifo Buana</strong>. All rights reserved.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FooterTwo;